export const GET_EARNING_OPTIONS = 'reference/earning_options';
